import { instance } from '@/services/klarbuss-api'
import { AxiosResponse } from 'axios'
import { UserInfo } from '@/types/user-info'

export function getUserInfo(): Promise<AxiosResponse<UserInfo>> {
  return instance.get(`/iam/user-info`)
}
